import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html, body, #root {
    min-height: 100%;
  }

  body {
    font-family: ${({ theme }) => theme.fonts.primary};
    color: ${({ theme }) => theme.colors.text.primary};
    background-color: ${({ theme }) => theme.colors.background.primary};
    line-height: 1.6;
    overflow-x: hidden;
  }

  /* Sticky footer: make the root a flex column that fills the viewport
     and let everything ABOVE the footer absorb remaining vertical space so the
     footer always sits at the bottom – even on short pages. */
  #root {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }

  /* The page layout is rendered through a Fragment with <Header />, content, <Footer />.
     Push the last child (the Footer) to the bottom of the viewport. */
  #root > footer {
    margin-top: auto;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  button {
    font-family: inherit;
  }

  img {
    max-width: 100%;
    height: auto;
  }
`;
